import { createSelector } from 'reselect';
import { AppState } from '$/store';
import * as Bixby from '$/core';

const getPublicCompaniesFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagPublicCompanies && _.isEnabled
    )
  );
};

const getClosFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(_ => _.id === Bixby.Configuration.releaseFeatureFlagClos && _.isEnabled)
  );
};

const getDocumentHostingFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagDocumentHosting && _.isEnabled
    )
  );
};

const getCompanyHistoryFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCompanyHistory && _.isEnabled
    )
  );
};

const getBixbyComplianceFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagBixbyCompliance && _.isEnabled
    )
  );
};

const getCreditSightsCovenantReviewFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCreditSightsCovenantReview && _.isEnabled
    )
  );
};

const getCreditSightsNewsIntegrationFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCreditSightsNewsIntegration && _.isEnabled
    )
  );
};

const getCreditSightsTranscriptionsIntegrationFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCreditSightsTranscriptionsIntegration && _.isEnabled
    )
  );
};

const getHasBixbyCompanyCompsFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCompanyComps && _.isEnabled
    )
  );
};

const getHistoricalFinancialModelsFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagHistoricalFinancialModels && _.isEnabled
    )
  );
};

const getSFDRFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(_ => _.id === Bixby.Configuration.releaseFeatureFlagSFDR && _.isEnabled)
  );
};

const getTreppCLOFeatureFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagTreppCLO && _.isEnabled
    )
  );
};

const getCloPermissioningFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagCloPermissioning && _.isEnabled
    )
  );
};

const getClientProvidedDataSitesFlag = ({ releaseFeatureFlagsState }: AppState) => {
  return (
    releaseFeatureFlagsState &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagClientProvidedDataSites && _.isEnabled
    )
  );
};

export const getPublicCompaniesFeatureFlagState = createSelector(
  [getPublicCompaniesFeatureFlag],
  (isPublicCompaniesEnabled: boolean) => ({ isPublicCompaniesEnabled })
);

export const getClosFeatureFlagState = createSelector([getClosFeatureFlag], (isClosEnabled: boolean) => ({
  isClosEnabled,
}));

export const getDocumentHostingFeatureFlagState = createSelector(
  [getDocumentHostingFeatureFlag],
  (isDocumentHostingEnabled: boolean) => ({ isDocumentHostingEnabled })
);

export const getCompanyHistoryFeatureFlagState = createSelector(
  [getCompanyHistoryFeatureFlag],
  (isCompanyHistoryEnabled: boolean) => ({ isCompanyHistoryEnabled })
);

export const getBixbyComplianceFeatureFlagState = createSelector(
  [getBixbyComplianceFeatureFlag],
  (isBixbyComplianceEnabled: boolean) => ({ isBixbyComplianceEnabled })
);

export const getCreditSightsCovenantReviewFeatureFlagState = createSelector(
  [getCreditSightsCovenantReviewFeatureFlag],
  (isCreditSightsCovenantReviewEnabled: boolean) => ({ isCreditSightsCovenantReviewEnabled })
);

export const getHasBixbyCompanyCompsFeatureFlagState = createSelector(
  [getHasBixbyCompanyCompsFeatureFlag],
  (isCompanyCompEnabled: boolean) => ({ isCompanyCompEnabled })
);

export const getCreditSightsNewsIntegrationEnabled = createSelector(
  [getCreditSightsNewsIntegrationFeatureFlag],
  (isCreditSightsNewsIntegrationEnabled: boolean) => ({ isCreditSightsNewsIntegrationEnabled })
);

export const getCreditSightsTranscriptionsIntegrationEnabled = createSelector(
  [getCreditSightsTranscriptionsIntegrationFeatureFlag],
  (isCreditSightsTranscriptionsIntegrationEnabled: boolean) => ({ isCreditSightsTranscriptionsIntegrationEnabled })
);

export const getHistoricalFinancialModelsEnabled = createSelector(
  [getHistoricalFinancialModelsFeatureFlag],
  (isHistoricalFinancialModelsEnabled: boolean) => ({ isHistoricalFinancialModelsEnabled })
);

export const getSFDREnabled = createSelector([getSFDRFeatureFlag], (isSFDREnabled: boolean) => ({ isSFDREnabled }));

export const getTreppCLOEnabled = createSelector([getTreppCLOFeatureFlag], (isTreppCLOEnabled: boolean) => ({
  isTreppCLOEnabled,
}));

export const getCloPermissioningEnabled = createSelector(
  [getCloPermissioningFlag],
  (isCloPermissioningEnabled: boolean) => ({ isCloPermissioningEnabled })
);

export const getClientProvidedDataSitesEnabled = createSelector(
  [getClientProvidedDataSitesFlag],
  (isClientProvidedDataSitesEnabled: boolean) => ({ isClientProvidedDataSitesEnabled })
);
